import { render, staticRenderFns } from "./activity.vue?vue&type=template&id=327eddd2&scoped=true&"
import script from "./activity.vue?vue&type=script&lang=js&"
export * from "./activity.vue?vue&type=script&lang=js&"
import style0 from "./activity.vue?vue&type=style&index=0&id=327eddd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327eddd2",
  null
  
)

component.options.__file = "activity.vue"
export default component.exports